import { margin as e, padding as t } from "./index37.js";
import { borderRadius as n, borderTransform as r } from "./index40.js";
import { columnGap as i, gap as a, rowGap as o } from "./index41.js";
import { paletteTransform as s } from "./index42.js";
import { maxWidth as c, sizingTransform as l } from "./index43.js";
//#region ../../node_modules/.pnpm/@mui+system@7.3.9_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.4__@emotion+st_bd245af145176c4b13a339c35b364ace/node_modules/@mui/system/esm/styleFunctionSx/defaultSxConfig.js
var u = {
	border: {
		themeKey: "borders",
		transform: r
	},
	borderTop: {
		themeKey: "borders",
		transform: r
	},
	borderRight: {
		themeKey: "borders",
		transform: r
	},
	borderBottom: {
		themeKey: "borders",
		transform: r
	},
	borderLeft: {
		themeKey: "borders",
		transform: r
	},
	borderColor: { themeKey: "palette" },
	borderTopColor: { themeKey: "palette" },
	borderRightColor: { themeKey: "palette" },
	borderBottomColor: { themeKey: "palette" },
	borderLeftColor: { themeKey: "palette" },
	outline: {
		themeKey: "borders",
		transform: r
	},
	outlineColor: { themeKey: "palette" },
	borderRadius: {
		themeKey: "shape.borderRadius",
		style: n
	},
	color: {
		themeKey: "palette",
		transform: s
	},
	bgcolor: {
		themeKey: "palette",
		cssProperty: "backgroundColor",
		transform: s
	},
	backgroundColor: {
		themeKey: "palette",
		transform: s
	},
	p: { style: t },
	pt: { style: t },
	pr: { style: t },
	pb: { style: t },
	pl: { style: t },
	px: { style: t },
	py: { style: t },
	padding: { style: t },
	paddingTop: { style: t },
	paddingRight: { style: t },
	paddingBottom: { style: t },
	paddingLeft: { style: t },
	paddingX: { style: t },
	paddingY: { style: t },
	paddingInline: { style: t },
	paddingInlineStart: { style: t },
	paddingInlineEnd: { style: t },
	paddingBlock: { style: t },
	paddingBlockStart: { style: t },
	paddingBlockEnd: { style: t },
	m: { style: e },
	mt: { style: e },
	mr: { style: e },
	mb: { style: e },
	ml: { style: e },
	mx: { style: e },
	my: { style: e },
	margin: { style: e },
	marginTop: { style: e },
	marginRight: { style: e },
	marginBottom: { style: e },
	marginLeft: { style: e },
	marginX: { style: e },
	marginY: { style: e },
	marginInline: { style: e },
	marginInlineStart: { style: e },
	marginInlineEnd: { style: e },
	marginBlock: { style: e },
	marginBlockStart: { style: e },
	marginBlockEnd: { style: e },
	displayPrint: {
		cssProperty: !1,
		transform: (e) => ({ "@media print": { display: e } })
	},
	display: {},
	overflow: {},
	textOverflow: {},
	visibility: {},
	whiteSpace: {},
	flexBasis: {},
	flexDirection: {},
	flexWrap: {},
	justifyContent: {},
	alignItems: {},
	alignContent: {},
	order: {},
	flex: {},
	flexGrow: {},
	flexShrink: {},
	alignSelf: {},
	justifyItems: {},
	justifySelf: {},
	gap: { style: a },
	rowGap: { style: o },
	columnGap: { style: i },
	gridColumn: {},
	gridRow: {},
	gridAutoFlow: {},
	gridAutoColumns: {},
	gridAutoRows: {},
	gridTemplateColumns: {},
	gridTemplateRows: {},
	gridTemplateAreas: {},
	gridArea: {},
	position: {},
	zIndex: { themeKey: "zIndex" },
	top: {},
	right: {},
	bottom: {},
	left: {},
	boxShadow: { themeKey: "shadows" },
	width: { transform: l },
	maxWidth: { style: c },
	minWidth: { transform: l },
	height: { transform: l },
	maxHeight: { transform: l },
	minHeight: { transform: l },
	boxSizing: {},
	font: { themeKey: "font" },
	fontFamily: { themeKey: "typography" },
	fontSize: { themeKey: "typography" },
	fontStyle: { themeKey: "typography" },
	fontWeight: { themeKey: "typography" },
	letterSpacing: {},
	textTransform: {},
	lineHeight: {},
	textAlign: {},
	typography: {
		cssProperty: !1,
		themeKey: "typography"
	}
};
//#endregion
export { u as default };

//# sourceMappingURL=index44.js.map